import React from 'react'
import HeaderMain from '../../Compoents/HeaderMain'
import FooterWhite from '../../Compoents/FooterWhite'
import BreadcrumbArea from '../../ShearOne/BreadcrumbArea'
import BlogList from './BlogList'
import MedtrustHeader from '../../Compoents/MedtrustHeader'
import MedtrustFooter from '../../Compoents/MedtrustFooter'
import { FocusPoint } from '../Appointments/MedtrustAbout'

const Blogs = () => {
  const breadcrumbLinks = [
    { path: '/', label: 'Home' },
    { label: 'Blogs', active: true }
  ];
  return (
    <>
    {/* <HeaderMain/> */}
    <MedtrustHeader />
    <main>
   
   <BreadcrumbArea 
     title="Blogs" 
     backgroundImage="/assets/imgs/breadcrumb/page-header-1.png" 
     links={breadcrumbLinks} 
   />

   
</main>

<BlogList/>
<FocusPoint />

    {/* <FooterWhite/> */}
    <MedtrustFooter />

    </>
  )
}

export default Blogs